// extracted by mini-css-extract-plugin
module.exports = {"marquee":"logo-marquee_marquee__xKjQx","logos":"logo-marquee_logos__rg24H","logo":"logo-marquee_logo__95Zac","is-animated":"logo-marquee_is-animated__ABYIf"};